import { createContext } from 'react'

import type { ContextType } from './types'

export const initialValues = {
  m2Case: {},
  loading: true,
  processing: {},
  refetch: () => {},
  id: '',
  processingId: '',
  processingType: {},
  error: null
}

export const defaultContext: ContextType = {
  processing: {},
  loading: initialValues.loading,
  m2Case: initialValues.m2Case,
  setCase: () => {},
  id: initialValues.id,
  setId: () => {},
  processingId: initialValues.processingId,
  setProcessingId: () => {},
  refetch: () => new Promise(() => {}),
  processingTypes: [],
  insurances: [],
  error: null
}

export const CaseContext = createContext<ContextType>(defaultContext)
